module.exports = __webpack_public_path__ + "static/artist-marketing-the-results-mobile-db621f94a309ba71bb68de6a9cb58d80.png";